import ConfirmationDelete from './ConfirmationDelete';

export default ConfirmationDelete;
